import './App.css';
import Mainpage from './Components/Mainpage';
import React from 'react';


function App() {
  return (
    <React.Fragment>
      <Mainpage />
    </React.Fragment>
  );
}

export default App;
